// extracted by mini-css-extract-plugin
module.exports = {"button":"button--ResetFiltersButton-LogsFilters-components__3h3Vg"};